
































import {Component, Prop, Vue} from 'vue-property-decorator';
import {nil} from '@/common';

@Component({
    components: {},
})
export default class ServiceListing extends Vue {

    @Prop({default: ''})
    public displayName!: string;

    @Prop({default: ''})
    public displayNameSubtitle!: string;

    @Prop({default: ''})
    public priceRange!: string;
    @Prop({default: ''})
    public description!: string;
    @Prop({default: () => undefined})
    public imagePath!: string;

    @Prop({default: '/book'})
    public bookPath!: string;

    public get imageSource() {
        let path = '../../img/services/5cf1baa0c45cc623910df22a.jpg';
        if (!nil(this.imagePath, true)) {
            path = this.imagePath;
        }
        return path;
    }
}
